import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Grid, Layout, Row, theme, Typography } from 'antd';
import { useTheme } from 'pos-client/theme/ThemeContext.ts';

interface AppFooterProps {
  style?: CSSProperties;
}

export const AppFooter = ({ style }: AppFooterProps) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();
  const { darkMode } = useTheme();
  const screens = Grid.useBreakpoint();

  const defaultFooterStyle: CSSProperties = {
    padding: `${token.paddingSM}px 0`,
    alignSelf: 'flex-end',
    width: '100%',
  };

  return (
    <Layout.Footer
      style={{
        ...defaultFooterStyle,
        ...style,
      }}
    >
      <Row justify="space-between" style={{ alignItems: 'center' }}>
        <Col
          span={24}
          style={{ justifyContent: screens.md ? undefined : 'space-between' }}
        >
          <Typography.Text
            strong
            style={{ color: darkMode ? token.blue : token.colorPrimary }}
          >
            &copy; {new Date().getFullYear()} {t('siteName')}
          </Typography.Text>
        </Col>
      </Row>
    </Layout.Footer>
  );
};
